import commons from './commons'
import validations from './validations'
import fields from './fields'
import pages from './pages'

export default {
  commons,
  validations,
  fields,
  pages,
}
